import { useQuery } from 'react-query';
import ProgressNote from '../../services/ProgressNote';
import { PROGRESS_NOTES } from '../../constants/reactQuery.keys';

export function useProgressNotes(patientId: number) {
  return useQuery([PROGRESS_NOTES, patientId], () => ProgressNote.getProgressNotes({ patientId }));
}
